import { Button } from '@99designs/common/components/Button';
import { FullscreenOverlay } from '@99designs/common/components/Fullscreen';
import { FormattedHTMLMessage } from '@99designs/common/i18n';
import Portal from 'common/components/Portal';
import React from 'react';

interface Props {
    brief: {
        id: string;
    };
}

interface State {
    hasDismissal: boolean;
}

class WelcomeOverlay extends React.Component<Props, State> {
    private flagKey = 'welcome_overlay_dismissed_flag_';

    constructor(props: Props) {
        super(props);
        this.flagKey += this.props.brief.id;
        this.state = {
            hasDismissal: this.hasDismissFlag(),
        };
    }

    setDismiss = () => {
        this.setState({ hasDismissal: true });
        localStorage.setItem(this.flagKey, 'true');
    };

    hasDismissFlag = () => localStorage.getItem(this.flagKey) == 'true';

    render = () => {
        return (
            <Portal>
                <FullscreenOverlay
                    isClosing={this.state.hasDismissal}
                    isActive={true}
                    hasOpeningAndClosingAnimation={true}
                    isScrollableSmallScreens={true}
                    enableScroll={true}
                    variations={['raised-modal', 'wide']}
                >
                    <div className="fullscreen-content">
                        <div className="welcome-overlay">
                            <img
                                className="welcome-overlay__icon"
                                src={require(`images/square/99d-x-square.svg`)}
                                width={450}
                            />
                            <h1>{__('Get matched with Square Online Store designers!')}</h1>
                            <FormattedHTMLMessage
                                message={__(
                                    "You're just a few steps away from connecting with qualified <strong>Square Online Store</strong> designers."
                                )}
                            />
                            <ol className="welcome-overlay__list">
                                <li>{__('Tell us a little about what you need')}</li>
                                <li>{__('Get matched with up to 5 talented experts')}</li>
                                <li>
                                    {__('Compare quotes and pick your favorite to get started!')}
                                </li>
                            </ol>
                            <div className="welcome-overlay__controls">
                                <Button onClick={this.setDismiss} variations={['primary', 'jumbo']}>
                                    {__('Get started')}
                                </Button>
                            </div>
                        </div>
                    </div>
                </FullscreenOverlay>
            </Portal>
        );
    };
}

export default WelcomeOverlay;
